import { Instance, types } from 'mobx-state-tree';

const ClientLesson = types.model('ClientLesson', {
	assessment_type_id: types.maybeNull(types.number),
	id: types.number,
	is_published: types.optional(types.union(types.number, types.boolean, types.null), 0),
	is_clil: types.optional(types.boolean, false),
	is_practiced_off: types.optional(types.boolean, false),
	lesson_type_id: types.maybeNull(types.number),
	module_id: types.maybeNull(types.number),
	name: types.maybeNull(types.optional(types.string, '')),
	program_id: types.maybeNull(types.number),
	sort_id: types.maybeNull(types.number),
	weight: types.maybeNull(types.string),
});

export default ClientLesson;

export interface IClientLessonModel extends Instance<typeof ClientLesson> {}
